import InterviewTipsNavIcon from "../../assets/InterviewTipsNavIcon";
import HomeNavIcon from "../../assets/HomeNavIcon";
import InterviewTipsGeneralNavIcon from "../../assets/InterviewTipsGeneralNavIcon";
import InterviewTipsResumeNavIcon from "../../assets/InterviewTipsResumeNavIcon";
import InterviewTipsRecruitersNavIcon from "../../assets/InterviewTipsRecruitersNavIcon";
import InterviewTipsCodingNavIcon from "../../assets/InterviewTipsCodingNavIcon";
import InterviewTipsMobileSystemDesignNavIcon from "../../assets/InterviewTipsMobileSystemDesignNavIcon";
import InterviewTipsBehavioralNavIcon from "../../assets/InterviewTipsBehavioralNavIcon";
import InterviewTipsTeamMatchingNavIcon from "../../assets/InterviewTipsTeamMatchingNavIcon";
import DataStructuresNavIcon from "../../assets/DataStructuresNavIcon";
import DataStructuresArrayNavIcon from "../../assets/DataStructuresArrayNavIcon";
import DataStructuresHashSetNavIcon from "../../assets/DataStructuresHashSetNavIcon";
import DataStructuresHashMapNavIcon from "../../assets/DataStructuresHashMapNavIcon";
import DataStructuresQueueNavIcon from "../../assets/DataStructuresQueueNavIcon";
import AppIconOutline from "../../assets/AppIconOutline";
import PrivacyNavIcon from "../../assets/PrivacyNavIcon";
import HomeScreen from "../../../home/HomeScreen";
import ITGeneralScreen from "../../../interviewtips/general/ITGeneralScreen";
import ITResumeScreen from "../../../interviewtips/resume/ITResumeScreen";
import ITRecruitersScreen from "../../../interviewtips/recruiters/ITRecruitersScreen";
import ITCodingInterviewScreen from "../../../interviewtips/coding/ITCodingScreen";
import ITMobileSystemDesignScreen from "../../../interviewtips/mobilesystemdesign/ITMobileSystemDesignScreen";
import ITBehavioralScreen from "../../../interviewtips/behavioral/ITBehavioralScreen";
import ITTeamMatchingScreen from "../../../interviewtips/teammatching/ITTeamMatchingScreen";
import DSArrayScreen from "../../../datastructures/array/DSArrayScreen";
import DSHashMapScreen from "../../../datastructures/hashmap/DSHashMapScreen";
import DSHashSetScreen from "../../../datastructures/hashset/DSHashSetScreen";
import AboutScreen from "../../../about/AboutScreen";
import PrivacyPolicyScreen from "../../../privacy/PrivacyPolicyScreen";
import DSQueueScreen from "../../../datastructures/queue/DSQueueScreen";
import DataStructuresStackNavIcon from "../../assets/DataStructuresStackNavIcon";
import DSStackScreen from "../../../datastructures/stack/DSStackScreen";

export const Paths = {
    home: {
        path: "/",
        name: "Home",
        tagline: "",
        icon: HomeNavIcon,
        screen: HomeScreen,
        nested: [],
    },
    interviewTips: {
        path: "/interview-tips",
        name: "Interview Tips",
        tagline: "",
        icon: InterviewTipsNavIcon,
        screen: null,
        nested: {
            general: {
                path: "/interview-tips/general",
                name: "General",
                tagline: "Tips & Tricks for those beginning their interview journey.",
                icon: InterviewTipsGeneralNavIcon,
                screen: ITGeneralScreen,
                nested: []
            },
            resume: {
                path: "/interview-tips/resume",
                name: "Resume",
                tagline: "How to get your resume seen by a recruiter and in the yes pile.",
                icon: InterviewTipsResumeNavIcon,
                screen: ITResumeScreen,
                nested: []
            },
            recruiters: {
                path: "/interview-tips/recruiters",
                name: "Recruiters",
                tagline: "They're people, too. Ones who want to help you land a job.",
                icon: InterviewTipsRecruitersNavIcon,
                screen: ITRecruitersScreen,
                nested: []
            },
            coding: {
                path: "/interview-tips/coding",
                name: "Coding",
                tagline: "You get out what you put in.",
                icon: InterviewTipsCodingNavIcon,
                screen: ITCodingInterviewScreen,
                nested: []
            },
            mobileSystemDesign: {
                path: "/interview-tips/mobile-system-design",
                name: "Mobile System Design",
                tagline: "How to ace Android and iOS Mobile System Design interviews.",
                icon: InterviewTipsMobileSystemDesignNavIcon,
                screen: ITMobileSystemDesignScreen,
                nested: []
            },
            behavioral: {
                path: "/interview-tips/behavioral",
                name: "Behavioral",
                tagline: "Way more important than you think.",
                icon: InterviewTipsBehavioralNavIcon,
                screen: ITBehavioralScreen,
                nested: []
            },
            teamMatching: {
                path: "/interview-tips/team-matching",
                name: "Team Matching",
                tagline: "Prepare for meeting with hiring managers.",
                icon: InterviewTipsTeamMatchingNavIcon,
                screen: ITTeamMatchingScreen,
                nested: []
            }
        }
    },
    dataStructures: {
        path: "/data-structures",
        name: "Data Structures",
        tagline: "",
        icon: DataStructuresNavIcon,
        screen: null,
        nested: {
            array: {
                path: "/data-structure/array",
                name: "Array",
                tagline: "A specified number of like-data in a set order.",
                icon: DataStructuresArrayNavIcon,
                screen: DSArrayScreen,
                nested: []
            },
            hashset: {
                path: "/data-structure/hashset",
                name: "HashSet",
                tagline: "A unique collection of keys with associated values, in no specified order.",
                icon: DataStructuresHashSetNavIcon,
                screen: DSHashSetScreen,
                nested: []
            },
            hashmap: {
                path: "/data-structure/hashmap",
                name: "HashMap",
                tagline: "A collection of unique values, with no specified order.",
                icon: DataStructuresHashMapNavIcon,
                screen: DSHashMapScreen,
                nested: []
            },
            queue: {
                path: "/data-structure/queue",
                name: "Queue",
                tagline: "A linear group of data in a specified first in, first out (FIFO) order.",
                icon: DataStructuresQueueNavIcon,
                screen: DSQueueScreen,
                nested: []
            },
            stack: {
                path: "/data-structure/stack",
                name: "Stack",
                tagline: "A linear group of data in a specified last in, first out (LIFO) order.",
                icon: DataStructuresStackNavIcon,
                screen: DSStackScreen,
                nested: []
            }
        }
    },
    about: {
        path: "/about-shesamobiledev",
        name: "About ShesAMobileDev",
        tagline: "",
        icon: AppIconOutline,
        screen: AboutScreen,
        nested: []
    },
    privacy: {
        path: "/privacy-policy",
        name: "Privacy Policy",
        tagline: "",
        icon: PrivacyNavIcon,
        screen: PrivacyPolicyScreen,
        nested: []
    }
}
